import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React  from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../state/AppStore'
import { createMVPModal } from '../Modal'
import { PaymentModalView } from './PaymentModalView'

class PaymentModal
{
	Show(success: boolean) 
	{
		NiceModal.show(createMVPModal('payment-modal', () =>
		{
			const modal = useModal()
			const user = useSelector((root: RootState) => root.activeUser.user)!

			return <PaymentModalView 
				user={user}
				success={success}
				
				clickConfirm={() => modal.hide()}
			/>
		}))
	}
}

const modal = new PaymentModal()
export default modal